import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-product-selection-dialog',
  templateUrl: './product-selection-dialog.component.html',
  styleUrls: ['./product-selection-dialog.component.css']
})
export class ProductSelectionDialogComponent {
  products = [
    { name: 'Casque Moto', quantity: 2, selected: false },
    { name: 'Pneu Avant 17"', quantity: 6, selected: false },
    { name: 'Batterie 12V', quantity: 4, selected: false },
    { name: 'Huile moteur 10W40', quantity: 5, selected: false },
    { name: 'Chaîne de transmission', quantity: 7, selected: false },
    { name: 'Bougie d’allumage', quantity: 3, selected: false }
  ];

  constructor(
    public dialogRef: MatDialogRef<ProductSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const selectedProducts = this.products
      .filter(product => product.selected)
      .map(({ name, quantity }) => ({ name, quantity }));

    this.dialogRef.close(selectedProducts);
  }
}
